import React from "react";
import {RWebShare} from "react-web-share";
import {View} from "react-native";
import {globalConfigurableData} from "../../utils/globalConstant";
import {TEST_API_D24} from "../../utils/apiUrl";
import {btoa} from "../../utils/commonMethods";
import { Icon } from '@iconify/react';

const ShareHashtag = ({hashtag}) => {
  const hashed = btoa(hashtag);
  const hash = hashtag.split("#")[1];
  return (
    <RWebShare
      data={{
        text:
          "Hey, checkout this trending hashtag \n" +
          hash +
          " Click on below link to participate",

        title: globalConfigurableData?.appName,
        url: TEST_API_D24 + `deeplink/?hashtag=${hashed}`,
      }}>
      <View>
        <Icon 
          icon="tabler:share-2"
          style={{width: 24, height: 24}}
          color={globalConfigurableData.primaryTextColor1}
        />
      </View>
    </RWebShare>
  );
};
export default ShareHashtag;
